import { useToast } from "../../../../hooks/useToast";
import { useCreateCheckoutSessionQuery } from "../../../../graphql/generated/schema";
import { useRoutes } from "../../../../hooks";
import { useAppSelector } from "../../../../state-management";

import {
  SEARCH_PARAM_PAYMENT_FOR,
  SEARCH_PARAM_PAYMENT_FOR_KEY,
} from "../../../../constants";
import { createSearchParams } from "react-router-dom";
import { useCurrentSearchParams } from "../../../../hooks/useCurrentSearchParams";
import { usePayment } from "../../../../hooks/usePayment";

interface CheckoutFormProps {
  isSubscription?: boolean;
}

function useStripeReturnUrl({ isSubscription }: CheckoutFormProps) {
  const { currentSearchParams } = useCurrentSearchParams();
  const { cardId } = usePayment();

  function getReturnUrl() {
    const currentPath = `${window.location.origin}${window.location.pathname}`;
    let returnUrl = "";
    if (isSubscription) {
      returnUrl = `${currentPath}?${createSearchParams({
        ...currentSearchParams,
        [SEARCH_PARAM_PAYMENT_FOR_KEY]: cardId
          ? SEARCH_PARAM_PAYMENT_FOR.SUB_W_CARD
          : SEARCH_PARAM_PAYMENT_FOR.SUB_ONLY,
      }).toString()}`;
    } else if (cardId) {
      returnUrl = `${currentPath}?${createSearchParams({
        ...currentSearchParams,
        [SEARCH_PARAM_PAYMENT_FOR_KEY]: SEARCH_PARAM_PAYMENT_FOR.SINGLE_CARD,
      }).toString()}`;
    } else {
      // Shouldn't get here. Investigate if it does
      returnUrl = window.location.href; // current url
    }

    return `${returnUrl}&session_id={CHECKOUT_SESSION_ID}`;
  }

  return {
    getReturnUrl,
  };
}

export function useStripeClientSecretForEmbeddedForm() {
  const { productId } = useRoutes();

  const selectedProduct = useAppSelector((state) => state.card.selectedProduct);
  const isPack = !!selectedProduct?.bundle || !!selectedProduct?.isBundle;
  const { getReturnUrl } = useStripeReturnUrl({ isSubscription: isPack });

  const { data, error } = useCreateCheckoutSessionQuery({
    variables: {
      input: { productId: productId ?? "", returnUrl: getReturnUrl() },
    },
    skip: !productId,
  });

  const clientSecret = data?.createCheckoutSession?.clientSecret;
  const showCreateCheckoutSessionErrorToast = !!error;

  // Setup toasts
  useToast({
    id: "createCheckoutSession",
    title: "Something went wrong",
    show: showCreateCheckoutSessionErrorToast,
    status: "error",
  });

  return {
    clientSecret,
  };
}
